import { createAction } from 'typesafe-actions'

export const applyBrand = createAction('CMD / Brand / apply')()
